import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { iconButton, mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  spacing = theme.spacing,
  text = theme.text;
var iconSize = 32;
export var iconbar = /*#__PURE__*/css(["display:flex;align-items:center;list-style-type:none;margin:0;padding:0;", ""], mediaQuery({
  min: minBreakpoints.L
}, css(["margin-right:-", ";"], pxToRem(20))));
export var focusedLink = /*#__PURE__*/css(["--iconColor:var(--brand-purple-base);"]);
export var link = /*#__PURE__*/css(["position:relative;display:flex;flex-direction:column;font-family:", ";font-weight:", ";", " text-decoration:none;color:var(--neutral-black-base);&:hover,&:active,&:focus{", "}"], fonts.PRIMARY_REGULAR.family, fonts.PRIMARY_REGULAR.weight, fontSize(text.BODY.XS), focusedLink);
export var icon = /*#__PURE__*/css(["width:", ";height:", ";"], pxToRem(iconSize), pxToRem(iconSize));
export var basketCount = /*#__PURE__*/css(["position:absolute;top:", ";right:", ";width:", ";text-align:center;pointer-events:none;", " span{display:inline-block;border-radius:", ";padding:0 ", ";min-width:", ";background-color:var(--functional-red-base);color:var(--neutral-white-base);", ";}"], pxToRem(-4), pxToRem(-16), pxToRem(42), mediaQuery({
  min: minBreakpoints.L
}, css(["right:", ";"], pxToRem(spacing.xs))), pxToRem(10), pxToRem(6), pxToRem(16), fontSize({
  fontSize: 12,
  lineHeight: 16
}));
export var iconBtn = /*#__PURE__*/css(["", " display:block;"], iconButton);